(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kapka-invoice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kapka-invoice')) {
  customElements.define('kapka-invoice', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.pending = Promise.resolve();
      this.addEventListener('change', () => {
        const enabled = this.querySelector('[data-invoice-toggle]').checked;
        this.querySelectorAll('[data-invoice-field]').forEach(input => {
          input.disabled = !enabled;
          input.required = enabled;
        });
        const attributes = {};
        this.querySelectorAll('input').forEach(input => {
          const key = input.name.slice(11, -1);
          attributes[key] = enabled ? (input.type === 'checkbox' ? 'Evet' : input.value) : '';
        });
        this.pending = this.pending.catch(() => {}).then(async () => {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
            method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({attributes})
          });
          if (!response.ok) throw new Error('invoice-save');
          this.querySelector('[data-invoice-error]').hidden = true;
        }).catch(error => {
          const message = this.querySelector('[data-invoice-error]');
          message.textContent = this.dataset.error;
          message.hidden = false;
          throw error;
        });
        this.pending.catch(() => {});
      });
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    const invoice = Array.from(document.querySelectorAll('kapka-invoice')).find(el => el.querySelector('input')?.form === form);
    if (!invoice || form.dataset.invoiceReady === 'true' || event.defaultPrevented) return;
    event.preventDefault();
    const submitter = event.submitter;
    try {
      await invoice.pending;
      if (!form.reportValidity()) return;
      // Gerçek tıklamada bu satıra ilk submit olayı hâlâ dağıtılırken gelinir; o anda
      // yapılan requestSubmit tarayıcı tarafından yok sayılır ve ödeme sayfasına geçilmez.
      // Bu yüzden yeniden gönderimi bir sonraki görev turuna erteliyoruz.
      setTimeout(() => {
        form.dataset.invoiceReady = 'true';
        if (submitter && submitter.isConnected && submitter.form === form) {
          form.requestSubmit(submitter);
        } else {
          // Buton yeniden çizildiyse "checkout" bilgisini gizli alanla taşı
          const checkoutField = document.createElement('input');
          checkoutField.type = 'hidden';
          checkoutField.name = 'checkout';
          form.appendChild(checkoutField);
          form.requestSubmit();
        }
        delete form.dataset.invoiceReady;
      }, 0);
    } catch { invoice.querySelector('details').open = true; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
